document.addEventListener('DOMContentLoaded', () => {

  const header = document.querySelector('.site-header');
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const navShell = document.querySelector('.nav-shell');
  const groups = document.querySelectorAll('.nav-group');

  if (header && menuToggle && navShell) {
    menuToggle.addEventListener('click', () => {
      const isOpen = header.classList.toggle('nav-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      if (!isOpen) groups.forEach((group) => group.removeAttribute('open'));
    });
  }

  groups.forEach((group) => {
    const summary = group.querySelector('summary');
    if (!summary) return;
    summary.addEventListener('click', () => {
      groups.forEach((openGroup) => {
        if (openGroup !== group) openGroup.removeAttribute('open');
      });
    });
  });

  document.addEventListener('click', (event) => {
    if (!header || header.contains(event.target)) return;
    groups.forEach((group) => group.removeAttribute('open'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    groups.forEach((group) => group.removeAttribute('open'));
    if (header && menuToggle) {
      header.classList.remove('nav-open');
      menuToggle.setAttribute('aria-expanded', 'false');
    }
  });



  const collapseMobileCollectionPanels = () => {
    if (!window.matchMedia('(max-width: 760px)').matches) return;
    document.querySelectorAll('.collection-section [data-mobile-collapsed], .collection-section .filter-group').forEach((panel) => {
      panel.removeAttribute('open');
    });
  };

  collapseMobileCollectionPanels();


  document.querySelectorAll('[data-browse-categories]').forEach((button) => {
    button.addEventListener('click', (event) => {
      const target = document.getElementById('category-navigation');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (header && menuToggle && window.matchMedia('(max-width: 749px)').matches) {
        header.classList.add('nav-open');
        menuToggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.querySelectorAll('.js-quick-add-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      const originalText = button ? button.textContent.trim() : '';
      if (button) {
        button.disabled = true;
        button.classList.add('is-loading');
        button.textContent = 'Adding...';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });

        if (!response.ok) throw new Error('Add to cart failed');
        const addedItem = await response.json();

        const cartResponse = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        let cart = null;
        if (cartResponse.ok) {
          cart = await cartResponse.json();
          document.querySelectorAll('.cart-count').forEach((count) => {
            count.textContent = cart.item_count;
          });
        }

        const drawer = document.querySelector('[data-cart-drawer]');
        const overlay = document.querySelector('[data-cart-drawer-overlay]');
        if (drawer && overlay) {
          const drawerTitle = drawer.querySelector('[data-cart-drawer-title]');
          const drawerPrice = drawer.querySelector('[data-cart-drawer-price]');
          const drawerQty = drawer.querySelector('[data-cart-drawer-qty]');
          const drawerImage = drawer.querySelector('[data-cart-drawer-image]');
          const drawerSubtotal = drawer.querySelector('[data-cart-drawer-subtotal]');
          if (drawerTitle) drawerTitle.textContent = addedItem.product_title || addedItem.title || 'Item';
          if (drawerPrice) drawerPrice.textContent = formatCartMoney(addedItem.final_line_price || addedItem.line_price || addedItem.price);
          if (drawerQty) drawerQty.textContent = 'Qty: ' + (addedItem.quantity || 1);
          if (drawerSubtotal && cart) drawerSubtotal.textContent = formatCartMoney(cart.total_price);
          const imageUrl = addedItem.featured_image && (addedItem.featured_image.url || addedItem.featured_image.src);
          if (drawerImage) {
            if (imageUrl) { drawerImage.src = imageUrl; drawerImage.hidden = false; }
            else { drawerImage.hidden = true; }
          }
          overlay.hidden = false;
          requestAnimationFrame(() => { overlay.classList.add('is-open'); drawer.classList.add('is-open'); });
          drawer.setAttribute('aria-hidden', 'false');
          document.body.classList.add('nms-cart-drawer-open');
        }

        if (button) {
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          button.textContent = 'Added';
          window.setTimeout(() => {
            button.disabled = false;
            button.classList.remove('is-added');
            button.textContent = originalText;
          }, 1600);
        }
      } catch (error) {
        if (button) {
          button.classList.remove('is-loading');
          button.classList.add('is-error');
          button.textContent = 'Unavailable';
          window.setTimeout(() => {
            button.disabled = false;
            button.classList.remove('is-error');
            button.textContent = originalText;
          }, 1800);
        }
      }
    });
  });


  const closeCartDrawer = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    const overlay = document.querySelector('[data-cart-drawer-overlay]');
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nms-cart-drawer-open');
    window.setTimeout(() => { overlay.hidden = true; }, 230);
  };

  document.querySelectorAll('[data-cart-drawer-close]').forEach((button) => button.addEventListener('click', closeCartDrawer));
  const cartDrawerOverlay = document.querySelector('[data-cart-drawer-overlay]');
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCartDrawer(); });

  const formatCartMoney = (cents) => {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
    } catch (error) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  };

  const refreshCartCount = (itemCount) => {
    document.querySelectorAll('.cart-count').forEach((count) => {
      count.textContent = itemCount;
    });
  };

  const updateCartLineNumbers = () => {
    document.querySelectorAll('[data-cart-line]').forEach((item, index) => {
      const line = index + 1;
      item.setAttribute('data-cart-line', String(line));
      const remove = item.querySelector('.js-cart-remove');
      if (remove) remove.setAttribute('data-line', String(line));
    });
  };

  document.querySelectorAll('.js-cart-remove').forEach((removeLink) => {
    removeLink.addEventListener('click', async (event) => {
      event.preventDefault();

      const line = Number(removeLink.getAttribute('data-line'));
      const cartItem = removeLink.closest('[data-cart-line]');
      if (!line || !cartItem) {
        window.location.href = removeLink.href;
        return;
      }

      removeLink.setAttribute('aria-disabled', 'true');
      cartItem.classList.add('is-removing');

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ line, quantity: 0 })
        });

        if (!response.ok) throw new Error('Cart remove failed');

        const cart = await response.json();
        refreshCartCount(cart.item_count);

        const subtotal = document.querySelector('[data-cart-subtotal]');
        if (subtotal) subtotal.textContent = formatCartMoney(cart.total_price);

        cartItem.addEventListener('transitionend', () => {
          cartItem.remove();
          updateCartLineNumbers();
          if (cart.item_count === 0) window.location.reload();
        }, { once: true });

        window.setTimeout(() => {
          if (document.body.contains(cartItem)) {
            cartItem.remove();
            updateCartLineNumbers();
            if (cart.item_count === 0) window.location.reload();
          }
        }, 450);
      } catch (error) {
        cartItem.classList.remove('is-removing');
        removeLink.removeAttribute('aria-disabled');
        window.location.href = removeLink.href;
      }
    });
  });


  const predictiveForms = document.querySelectorAll('[data-predictive-search-form]');
  const escapeHTML = (value) => String(value || '').replace(/[&<>"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[char]));
  const stripHTML = (value) => String(value || '').replace(/<[^>]*>/g, '');
  const getPredictiveImage = (image) => {
    if (!image) return '';
    if (typeof image === 'string') return image;
    if (image.url) return image.url;
    if (image.src) return image.src;
    return '';
  };
  const getProductSubtitle = (product) => {
    const sku = product && product.variants && product.variants[0] && product.variants[0].sku ? product.variants[0].sku : '';
    const parts = [product.vendor || product.product_type || '', sku ? 'Part # ' + sku : ''].filter(Boolean);
    return parts.join(' • ');
  };
  const formatSuggestionTitle = (title, query) => {
    const safeTitle = escapeHTML(stripHTML(title));
    const cleanQuery = String(query || '').trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if (!cleanQuery) return safeTitle;
    try {
      return safeTitle.replace(new RegExp('(' + cleanQuery + ')', 'ig'), '<mark>$1</mark>');
    } catch (error) {
      return safeTitle;
    }
  };

  predictiveForms.forEach((form) => {
    const input = form.querySelector('[data-predictive-search-input]');
    const panel = form.querySelector('[data-predictive-search-results]');
    if (!input || !panel) return;

    let debounceTimer;
    let activeController;

    const hidePanel = () => {
      panel.hidden = true;
      panel.innerHTML = '';
      form.classList.remove('is-searching');
    };

    const renderSuggestions = (data, query) => {
      const resources = data && data.resources && data.resources.results ? data.resources.results : {};
      const products = resources.products || [];

      if (!products.length) {
        panel.innerHTML = '<div class="predictive-search-heading">Products</div><div class="predictive-search-empty">No close product matches. Press Enter to search the full catalog.</div>';
        panel.hidden = false;
        return;
      }

      const items = products.slice(0, 5).map((product) => {
        const imageUrl = getPredictiveImage(product.image || product.featured_image);
        const image = imageUrl ? '<span class="predictive-search-image"><img src="' + escapeHTML(imageUrl) + '" alt=""></span>' : '<span class="predictive-search-image predictive-search-image-placeholder">⌕</span>';
        const subtitle = getProductSubtitle(product);
        return '<a class="predictive-search-item" href="' + escapeHTML(product.url) + '">' +
          image +
          '<span class="predictive-search-copy"><strong>' + formatSuggestionTitle(product.title, query) + '</strong>' +
          (subtitle ? '<small>' + escapeHTML(subtitle) + '</small>' : '') +
          '</span></a>';
      }).join('');

      panel.innerHTML = '<div class="predictive-search-heading">Matching products</div>' + items + '<a class="predictive-search-all" href="/search?q=' + encodeURIComponent(query) + '">See all product results for “' + escapeHTML(query) + '”</a>';
      panel.hidden = false;
    };

    const fetchSuggestions = async () => {
      const query = input.value.trim();
      if (query.length < 2) {
        hidePanel();
        return;
      }

      if (activeController) activeController.abort();
      activeController = new AbortController();
      form.classList.add('is-searching');

      try {
        const params = new URLSearchParams();
        params.set('q', query);
        params.set('resources[type]', 'product');
        params.set('resources[limit]', '10');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', 'title,product_type,variants.sku,vendor');

        const response = await fetch('/search/suggest.json?' + params.toString(), {
          headers: { 'Accept': 'application/json' },
          signal: activeController.signal
        });
        if (!response.ok) throw new Error('Predictive search failed');
        const data = await response.json();

        // Shopify's predictive-search endpoint does not reliably honor tag exclusions.
        // Verify each suggested product against its storefront product JSON before
        // rendering anything, so Pending Dealer items never flash in autocomplete.
        const resources = data && data.resources && data.resources.results ? data.resources.results : {};
        const suggestedProducts = resources.products || [];
        const checkedProducts = await Promise.all(suggestedProducts.map(async (suggestedProduct) => {
          try {
            const productPath = new URL(suggestedProduct.url, window.location.origin).pathname.replace(/\/$/, '');
            const productResponse = await fetch(productPath + '.js', {
              headers: { 'Accept': 'application/json' },
              signal: activeController.signal
            });
            if (!productResponse.ok) return suggestedProduct;
            const fullProduct = await productResponse.json();
            const tags = Array.isArray(fullProduct.tags) ? fullProduct.tags : [];
            const isPendingDealer = tags.some((tag) => String(tag).trim().toLowerCase() === 'pending dealer');
            return isPendingDealer ? null : suggestedProduct;
          } catch (error) {
            if (error.name === 'AbortError') throw error;
            // Fail closed: if visibility cannot be verified, do not expose the suggestion.
            return null;
          }
        }));

        data.resources.results.products = checkedProducts.filter(Boolean).slice(0, 5);
        renderSuggestions(data, query);
      } catch (error) {
        if (error.name !== 'AbortError') hidePanel();
      } finally {
        form.classList.remove('is-searching');
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(fetchSuggestions, 180);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2 && panel.innerHTML.trim()) panel.hidden = false;
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') hidePanel();
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) hidePanel();
    });
  });


  const formatCollectionDisplayTitle = (rawTitle) => {
    if (!rawTitle) return '';
    const normalized = rawTitle.replace(/\s+[-–—]\s+/g, ' - ').trim();
    if (!normalized.includes(' - ')) return rawTitle.trim();
    const parts = normalized.split(' - ').map((part) => part.trim()).filter(Boolean);
    if (!parts.length) return rawTitle.trim();
    const last = parts[parts.length - 1];
    const second = parts.length > 1 ? parts[1] : '';
    const secondLower = second.toLowerCase();
    const lastLower = last.toLowerCase();

    if (secondLower === 'lights') {
      if (lastLower.includes('under water') || lastLower.includes('underwater')) return 'Underwater Lights';
      if (lastLower.includes('flood')) return 'Flood Lights';
      if (lastLower.includes('spreader')) return 'Spreader Lights';
      if (lastLower.includes('spotlight')) return lastLower.includes('accessor') ? 'Spotlight Accessories' : 'Spotlights';
      if (lastLower.includes('light bar')) return 'Light Bars';
      if (lastLower.includes('navigation')) return 'Navigation Lights';
      return last + ' Lights';
    }

    if (secondLower === 'battery') return 'Battery ' + last;
    if (secondLower === 'radar') return 'Radar ' + last;
    if (secondLower === 'antenna') return last + ' Antenna';
    if (secondLower === 'gauges') return 'Gauges ' + last;
    if (secondLower === 'transducer') return last + ' Transducers';
    if (secondLower === 'gps') return 'GPS ' + last;
    if (secondLower === 'fishfinder') return 'Fishfinder ' + last;
    if (secondLower === 'vhf') return last + ' VHF';
    if (secondLower === 'autopilot') return 'Autopilot ' + last;
    return last;
  };

  document.querySelectorAll('[data-collection-header]').forEach((header) => {
    const originalTitle = header.getAttribute('data-original-title') || '';
    const displayTitle = formatCollectionDisplayTitle(originalTitle);
    const titleNode = header.querySelector('[data-collection-display-title]');
    const introNode = header.querySelector('[data-collection-intro]');
    if (displayTitle && titleNode) titleNode.textContent = displayTitle;
    if (displayTitle && introNode && !introNode.textContent.trim()) {
      introNode.textContent = 'Explore trusted ' + displayTitle.toLowerCase() + ' built for clean installs, reliable performance, and better days on the water.';
    } else if (displayTitle && introNode) {
      introNode.textContent = 'Explore trusted ' + displayTitle.toLowerCase() + ' built for clean installs, reliable performance, and better days on the water.';
    }
  });

  const focusSearchFromHash = () => {
    if (window.location.hash !== '#site-search' && window.location.hash !== '#catalog-search') return;
    const form = document.querySelector(window.location.hash);
    const input = form ? form.querySelector('[data-predictive-search-input], input[type="search"]') : null;
    if (!input) return;
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(() => input.focus(), 350);
  };

  focusSearchFromHash();
  window.addEventListener('hashchange', focusSearchFromHash);

});


// Navesink: seamless collection filtering/sorting without a visible page reload or scroll jump.
(function() {
  const toolsSelector = '[data-collection-tools]';
  let activeController = null;

  const buildUrlFromForm = (form) => {
    const params = new URLSearchParams(new FormData(form));
    const action = form.getAttribute('action') || window.location.pathname;
    const query = params.toString();
    return action + (query ? '?' + query : '');
  };

  const replaceCollectionTools = async (url, pushState) => {
    const currentTools = document.querySelector(toolsSelector);
    if (!currentTools) {
      window.location.href = url;
      return;
    }

    if (activeController) activeController.abort();
    activeController = new AbortController();

    currentTools.classList.add('is-filtering');
    currentTools.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, {
        headers: { 'Accept': 'text/html' },
        signal: activeController.signal
      });
      if (!response.ok) throw new Error('Collection filter request failed');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newTools = doc.querySelector(toolsSelector);
      const newTitle = doc.querySelector('title');

      if (!newTools) throw new Error('Collection tools not found in response');

      currentTools.replaceWith(newTools);
      if (newTitle) document.title = newTitle.textContent;
      if (pushState) window.history.pushState({ navesinkCollectionUrl: url }, '', url);
    } catch (error) {
      if (error.name !== 'AbortError') window.location.href = url;
    }
  };

  document.addEventListener('change', function(event) {
    const target = event.target;
    if (!target || !target.closest) return;

    const filterForm = target.closest('form[data-auto-filter-form]');
    if (filterForm && (target.matches('input[type="checkbox"]') || target.matches('input[type="number"]'))) {
      event.preventDefault();
      replaceCollectionTools(buildUrlFromForm(filterForm), true);
      return;
    }

    const sortForm = target.closest('form[data-auto-sort-form]');
    if (sortForm && target.matches('select[name="sort_by"]')) {
      event.preventDefault();
      replaceCollectionTools(buildUrlFromForm(sortForm), true);
    }
  });

  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (!form || !form.matches || (!form.matches('form[data-auto-filter-form]') && !form.matches('form[data-auto-sort-form]'))) return;
    event.preventDefault();
    replaceCollectionTools(buildUrlFromForm(form), true);
  });

  document.addEventListener('click', function(event) {
    const clearLink = event.target && event.target.closest ? event.target.closest('[data-filter-clear]') : null;
    if (!clearLink) return;
    event.preventDefault();
    replaceCollectionTools(clearLink.href, true);
  });

  window.addEventListener('popstate', function() {
    replaceCollectionTools(window.location.href, false);
  });
})();

/* NMS product landing page: variant details and image gallery */
document.addEventListener('DOMContentLoaded', () => {
  const dataNode = document.getElementById('nms-product-variants');
  if (!dataNode) return;
  let variants;
  try { variants = JSON.parse(dataNode.textContent); } catch (e) { return; }
  const select = document.getElementById('variant-select-top');
  const price = document.querySelector('[data-nms-price]');
  const compare = document.querySelector('[data-nms-compare]');
  const sku = document.querySelector('[data-nms-sku]');
  const stock = document.querySelector('[data-nms-stock]');
  const button = document.querySelector('[data-nms-add-button]');
  const money = (cents) => new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}).format(cents / 100);
  if (select) select.addEventListener('change', () => {
    const variant = variants.find(v => String(v.id) === select.value);
    if (!variant) return;
    if (price) price.textContent = money(variant.price);
    if (compare) {
      compare.hidden = !(variant.compare_at_price > variant.price);
      compare.textContent = !compare.hidden ? money(variant.compare_at_price) : '';
    }
    if (sku) sku.textContent = variant.sku || '';
    if (stock) stock.textContent = !variant.available ? 'Currently unavailable' : (variant.inventory_management && variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue' ? 'Available to order' : 'Available for purchase');
    if (button) { button.disabled = !variant.available; button.textContent = variant.available ? 'Add to Cart →' : 'Sold Out'; }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  });
  const mainImage = document.getElementById('nms-main-product-image');
  document.querySelectorAll('[data-nms-image-url]').forEach(thumb => thumb.addEventListener('click', () => {
    if (!mainImage) return;
    mainImage.src = thumb.dataset.nmsImageUrl;
    mainImage.removeAttribute('srcset');
    mainImage.alt = thumb.dataset.nmsImageAlt || '';
    document.querySelectorAll('[data-nms-image-url]').forEach(item => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
  }));
});
